import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

import { localTime } from './utc-time';

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(relativeTime);
export function formatDuration(
  start: dayjs.Dayjs | Date,
  end: dayjs.Dayjs | Date = dayjs.utc()
) {
  const startDate = start instanceof Date ? localTime(start) : start;
  const endDate = end instanceof Date ? localTime(end) : end;
  return dayjs.duration(endDate.diff(startDate)).humanize();
}
